import axios from 'axios';

export const callApi = async (options, auth = false, body = false, query = false) => {
  try {

    //Manipulate Axios options to add auth if needed
    if (auth) {
      options = {
        ...options,
        headers: {
          Authorization: `Bearer ${auth}`,
        },
      }
    }

    //Manipulate Axios options to add body(data) if needed
    if (body) {
      options = {
        ...options,
        data: body,
      }
    }

    //Manipulate Axios options to add query params if needed
    if (query) {
      options = {
        ...options,
        params: query,
      }
    }

    const response = await axios(options);
    const { headers, data, status, statusText } = response;

    return {
      headers,
      data,
      status,
      statusText,
      error: null,
    };

  } catch (error) {

    if (axios.isAxiosError(error)) {
      const axiosError = error;

      const { response } = axiosError;

      let status;
      let alert;
      let message = 'Request failed';

      if (response && response.statusText) {
        message = response.statusText;
      }

      if (axiosError.message) {
        message = axiosError.message;
      }

      //Check if the alert object exists
      if (response && response.data && response.status && response.data.message && response.data.alert) {
        message = response.data.message;
        status = response.status;
        alert = response.data.alert;

      } else if (!response && axiosError.code === 'ERR_NETWORK') {
        //If the error is a network error

        alert = {
          type: 'error',
          title: 'Could not connect',
          text: 'Could not connect to server. Please check your network connection',
        }

        status = 'ERR_NETWORK';
      }

      return {
        headers: null,
        data: null,
        error: {
          status,
          message,
          alert,
        },
      };
    }

    return {
      headers: null,
      data: null,
      error: {
        message: error.message,
      },
    };
  }
};
